import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { useHistory } from 'react-router-dom';
import { Pages } from '../../utils/constants';

export interface IMaxAssociateWarningModalProps {
  onClose: () => void;
  visible: boolean;
}

export const MaxAssociateWarningModal = ({ onClose, visible }: IMaxAssociateWarningModalProps) => {
  const history = useHistory();

  return (
    <Modal
      id="max-associate-warning-modal"
      open={visible}
      size="small"
      onClose={onClose}
      variants={{
        xs: 'bottom-sheet',
        sm: 'bottom-sheet',
        md: 'regular',
        lg: 'regular',
        xl: 'regular',
      }}
    >
      <ModalTitle id="max-associate-warning-title">
        Unable to add family member
        <ModalCloseIconButton
          aria-label="Close"
          id="modalCloseButton"
          onClick={() => {
            history.push(Pages.HomePage);
          }}
        />
      </ModalTitle>
      <ModalContent id="max-associate-warning-content">
        <Typography variant="b1Regular" sx={{ marginBottom: '1rem' }}>
          You cannot add additional family members because you have reached the maximum allowed limit.
        </Typography>
      </ModalContent>
      <ModalActions
        actionLayout={{
          xs: 'fullWidth',
          sm: 'fullWidth',
          md: 'fullWidth',
          lg: 'fullWidth',
          xl: 'fullWidth',
        }}
      >
        <ModalActionButton
          id="max-associate-warning-button"
          label={'Got it'}
          onClick={() => {
            history.push(Pages.HomePage);
          }}
          variant="contained"
          fullWidth
        />
      </ModalActions>
    </Modal>
  );
};
